import React from 'react';
import background from '../images/dancedance2.gif';
import './home.scss';
import { ReactComponent as DoubleQuote } from '../images/doubleQuote2.svg';
// import { ReactComponent as Feather } from '../images/feather.svg';
import { ReactComponent as MobileFeather } from './mobile-feather.svg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuoteRight, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
import { MediaQueryContext } from '../MediaQueryContext';
import Feather from './feather_4.gif';

class Home extends React.Component {
  static contextType = MediaQueryContext;

  constructor() {
    super();
    this.state = { x: 0, y: 0 };
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  componentDidMount() {
  }

  handleMouseMove(e) {
    this.setState({ x: e.pageX, y: e.pageY });
  }

  render() {
    let leftRatio = (this.state.x / window.innerWidth);
    //let rightRatio = 100 - leftRatio;
    let topRatio = (this.state.y / window.innerHeight);
    let backgroundX1 = ((0.5 - leftRatio) * 30);
    let backgroundX2 = ((0.5 - leftRatio) * -30);
    let backgroundY1 = ((0.5 - topRatio) * 30);
    let backgroundY2 = ((0.5 - topRatio) * -30);
    let style1 = { transform: `translate(${backgroundX1}vw, ${backgroundY1}vh)` };
    let style2 = { transform: `translate(${backgroundX2}vw, ${backgroundY2}vh)` };

    return (
      <div className="home" onMouseMove={this.handleMouseMove} >
        <div className="backgrounds">
          <img src={background} className="background" id="background-1" alt="a man dancing" />
          <img src={background} className="background" id="background-2" alt="a man dancing" style={style1} />
          <img src={background} className="background" id="background-3" alt="a man dancing" style={style2} />
        </div>

        <div className="home-content">
          {this.context.isMobile && <div> <MobileFeather className="feather" /> </div>}
          {this.context.isDesktop && <div className="left-content">
            <DoubleQuote className="double-quote" />
            <img src={Feather} className="feather" />

            <i>
              <span>Skin remembers how long the years grow</span><br />
              <span> when skin is not touched, a gray tunnel</span><br />
              <span>of singleness, feather lost from the tail</span><br />
              <span>of a bird, swirling onto a step,</span><br />
              <span>swept away by someone who never saw</span><br />
              <span>it was a feather…</span></i>
            <span className="name">Naomi Shihab Nye</span>

          </div>}
          <div className="right-content">
            {/* {this.context.isMobile ? <MobileFeather ref={this.feather} className="feather"/> : <Feather ref={this.feather} className="feather"/>} */}

            <h1>Skin Remembers</h1>
            <h2>stories and identities of the few</h2>
            <h3>An audio-visual exhibition where individuals with a minority background from Iraq, Palestine, Syria and Sàpmi share their thoughts and feelings on identity</h3>
            <br />
            <h3>En audiovisuell utstilling hvor individer med minoritetsbakgrunn fra Irak, Palestina, Syria og Sàpmi forteller om tanker og følelser knyttet til sin identitet</h3>
            <div className="footer">
              <Link to="/full-poem" className="button secondary">
                <FontAwesomeIcon color="#DE513E" icon={faQuoteRight} />
                <span>READ FULL POEM</span>
              </Link>
              <span className="or-spacer">OR</span>
              <Link to="/stations" className="button primary">
                <span>ENTER</span>
                <FontAwesomeIcon color="#231F20" icon={faArrowRight} />

              </Link>
            </div>
          </div>

          {/* {this.context.isMobile ? <MobileFeather ref={this.feather} className="feather"/> : <Feather ref={this.feather} className="feather"/>} */}

        </div>

      </div>
    );
  }
}

export default Home;
